import { css } from 'styled-components';
import { OnlineThemeType } from '../../themes/online';

export const Content = ({ theme }: { theme: OnlineThemeType }) => {
  return css`
    padding-top: 50px;
    padding-inline: ${theme.spacing.larger}px;
    font-family: 'Poppins';
    flex: 1;
    width: calc(100vw - 272px);
    overflow-y: scroll;

    & .title {
      text-align: left;
      margin-bottom: 30px;
      font-family: 'Poppins';
      font-size: 30px;
      color: ${theme.colors.primaryBackground};
      font-weight: 600;
    }

    @media ${theme.device.max.tabletS} {
      width: auto;
      padding: 20px;
      max-height: none;
      min-width: auto;
    }

    @media ${theme.device.max.laptopM} {
      min-width: calc(100vw - 252px);
    }

    @media ${theme.device.max.laptop} {
      min-width: calc(100vw - 214px);
    }
  `;
};
